import { useCallback } from "react";
import { useApiBase } from "../../base/api-base";
import { CredenciaisDadosModel } from "../../../../model/api/credenciais/credenciais-dados-model";

export function usePostRedirecionarCredencial() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postRedirecionarCredencial = useCallback(
        (lojaId: string, codigoAplicacao: number, model?: CredenciaisDadosModel) => {
            return invocarApi({
                url: `/api/v2/loja/${lojaId}/credencial-dados/${codigoAplicacao}/redirecionar`,
                method: "POST",
                data: model,
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );
    return {
        ...outrasPropriedades,
        postRedirecionarCredencial,
    };
}


